import React, {useEffect, useState} from 'react';
import {Modal, Table, Tag} from 'antd';
import axiosApiInstance from '../../../api/axiosClient';
import dayjs from 'dayjs';

interface FetchHistoryEntry {
    id: number;
    account_id: number;
    action_type: string;
    status: string;
    error_message?: string;
    data_before?: string;
    data_after?: string;
    source: string;
    created_at: string;
}

interface Props {
    accountId: number | null;
    accountName?: string;
    open: boolean;
    onClose: () => void;
}

const columns = [
    {
        title: 'Date',
        dataIndex: 'created_at',
        key: 'created_at',
        render: (v: string) => dayjs(v).format('DD/MM/YYYY HH:mm'),
        width: 150,
    },
    {
        title: 'Action',
        dataIndex: 'action_type',
        key: 'action_type',
        width: 120,
    },
    {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        width: 90,
        render: (v: string) => (
            <Tag color={v === 'success' ? 'green' : 'red'}>{v}</Tag>
        ),
    },
    {
        title: 'Source',
        dataIndex: 'source',
        key: 'source',
        width: 90,
    },
    {
        title: 'Before',
        dataIndex: 'data_before',
        key: 'data_before',
        width: 100,
    },
    {
        title: 'After',
        dataIndex: 'data_after',
        key: 'data_after',
        width: 100,
    },
    {
        title: 'Error',
        dataIndex: 'error_message',
        key: 'error_message',
        ellipsis: true,
    },
];

const FetchHistoryModal: React.FC<Props> = ({accountId, accountName, open, onClose}) => {
    const [data, setData] = useState<FetchHistoryEntry[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (open && accountId) {
            setLoading(true);
            axiosApiInstance
                .get(`/api/creators/accounts/${accountId}/fetch-history`)
                .then((res) => setData(Array.isArray(res.data) ? res.data : []))
                .catch(() => setData([]))
                .finally(() => setLoading(false));
        }
    }, [open, accountId]);

    return (
        <Modal
            title={`Fetch History${accountName ? ` — ${accountName}` : ''}`}
            open={open}
            onCancel={onClose}
            footer={null}
            width={900}
            destroyOnClose
        >
            <Table
                columns={columns}
                dataSource={data}
                rowKey="id"
                loading={loading}
                size="small"
                pagination={{pageSize: 10}}
            />
        </Modal>
    );
};

export default FetchHistoryModal;
